<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created () {
    window.localStorage.removeItem('drillData')

  },
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: none;
  box-sizing: border-box;
  -webkit-text-size-adjust:none;
}
#app{
background-color:#fff;

}
input {
  -webkit-appearance: none;
}
html,body{
  height: 100%;
  width: 100%;
}
#app{
  height: 100%;
  width: 100%;
  overflow: hidden;
}
input{
   background:none;
   outline:none;
   border:0px;
}
.inner-picker{
  /*border-bottom: 1px solid rgba(242,242,242,.1);*/
}
.inner-picker .picker-items .picker-slot{
  font-size: 12px;
}
.inner-picker .picker-items .picker-slot .picker-slot-wrapper .picker-item{
  padding: 0;
}
.inner-picker .picker-center-highlight{
  border-top: 1px solid #5483D2;
  border-bottom: 1px solid #5483D2;

}
.inner-picker .picker-center-highlight:before,.inner-picker .picker-center-highlight:after {
  background-color: #5483D2;
  display: none;
}
.inner-picker .picker-item.picker-selected{
  color: #5483D2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue